/**
 * Aeris B2B Portal – optionale Komfort-Ergänzung.
 *
 * Der Familienwechsel selbst ist reine Server-Navigation (Klick auf eine
 * Konfigurator-Kachel = normaler Link), siehe
 * sections/aeris-b2b-portal.liquid. Hier läuft KEINE
 * Konfigurator-Logik. Dieses Skript sorgt nur für sofortiges visuelles
 * Feedback beim Klick auf eine Kachel, während die neue Seite lädt – es ist
 * nicht zwingend nötig und kann ohne Funktionsverlust entfernt werden.
 *
 * UNVERÄNDERT gegenüber V1: Die Klassen-Selektoren (.aeris-b2b-portal__tab)
 * passen weiterhin, da die neuen Theme-Editor-Blocks (siehe 8.3) dieselbe
 * Markup-Struktur erzeugen wie die frühere hartcodierte Liste.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var tabs = document.querySelectorAll('.aeris-b2b-portal__tab');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('is-active')) {
          return;
        }
        tabs.forEach(function (t) {
          t.classList.remove('is-loading');
        });
        tab.classList.add('is-loading');
      });
    });
  });
})();
